import React from "react";
import "../../styles/CaseStudyThree/CaseStudiesHero3.css";

const CaseStudiesHero3 = () => {
  return (
    <section id="case-studies-hero-three" className="case-studies-hero3">
      <div className="hero-container3">
        {/* Left Content */}
        <div className="hero-left3">
          <h2 className="hero-subtitle3">Audience Optimization </h2>
          <h1 className="hero-title3">Hawx Pest Control</h1>
          <p className="hero-description3">
          Hawx Pest Control partnered with us to refine their audience targeting strategy. By excluding lower-income households and younger audiences unlikely to own homes, we reduced the cost per lead (CPL) by 75%. 
          This laser-focused approach ensured that ad spend was allocated only to qualified, high-intent audiences.
          </p>
          <ul className="hero-kpi-list3">
            <li className="kpi-item3">
              <div className="case-study-checkmark-icon3"></div> Decreased cost per lead (CPL) by 75%
            </li>
            <li className="kpi-item3">
              <div className="case-study-checkmark-icon3"></div> Improved lead quality
            </li>
            <li className="kpi-item3">
              <div className="case-study-checkmark-icon3"></div> Enhanced targeting efficiency
            </li>
          </ul>
        </div>

        {/* Right Image */}
        <div className="hero-right3">
          <div className="hero-image-container3">
            <img
              src={require("../../assets/hawx-logo-big.png")} // Replace with your image path
              alt="Bullfrog Logo"
              className="hero-image3"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesHero3;
